module.exports = __webpack_public_path__ + "img/Logo.168b45fe.svg";